// ============================================================================
// CHINESE (SIMPLIFIED) TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// 从神话语中提取的属灵珍宝

export const bibleTreasures = [
  {
    type: "perle_sagesse",
    content: "神圣的智慧不是抽象的理论，而是在我们日常选择中显现的具体生活",
    reference: "箴言 3:13-18",
    category: "智慧",
    strongNumbers: {
      "智慧": "H2451", // חָכְמָה (chokmah) = 实践智慧
      "聪明": "H8394" // תְּבוּנָה (tebunah) = 洞察力
    },
    reflection: "我今天如何在决策中应用神的智慧？"
  },
  {
    type: "tresor_divine",
    content: "神的爱不取决于我们的功劳，而是从祂自身本性流出的永恒恩赐",
    reference: "罗马书 8:38-39",
    category: "爱",
    strongNumbers: {
      "爱": "G26", // ἀγάπη (agape) = 无条件的爱
      "隔绝": "G5563" // χωρίζω (chorizo) = 分离
    },
    reflection: "没有任何事能使我们与神在基督里显明的爱隔绝"
  },
  {
    type: "lumiere_vie",
    content: "耶稣是照亮我们道路和内在生命的光",
    reference: "约翰福音 8:12",
    category: "身份",
    strongNumbers: {
      "光": "G5457", // φῶς (phos) = 光
      "生命": "G2222" // ζωή (zoe) = 丰盛的生命
    },
    reflection: "我如何让基督的光照亮我黑暗的地方？"
  },
  {
    type: "force_divine",
    content: "我们的力量不是来自自己，而是来自住在我们里面的那一位",
    reference: "以弗所书 3:16-17",
    category: "能力",
    strongNumbers: {
      "刚强": "G2901", // κραταιόω (krataioo) = 加强
      "能力": "G1411" // δύναμις (dynamis) = 神圣能力
    },
    reflection: "在软弱时刻，我是否信靠神的力量？"
  },
  {
    type: "paix_profonde",
    content: "神的平安不依赖外在环境，而是依赖祂在我们心中的持续同在",
    reference: "腓立比书 4:6-7",
    category: "宁静",
    strongNumbers: {
      "平安": "G1515", // εἰρήνη (eirene) = 完全的平安
      "保守": "G5432" // φρουρέω (phroureo) = 像堡垒般守护
    },
    reflection: "我如何培养那超越人所能理解的神的平安？"
  },
  {
    type: "esperance_vivante",
    content: "我们的盼望不是不确定的愿望，而是建立在神信实应许上的坚固锚",
    reference: "希伯来书 6:19",
    category: "盼望",
    strongNumbers: {
      "盼望": "G1680", // ἐλπίς (elpis) = 确信的盼望
      "锚": "G45" // ἄγκυρα (ankyra) = 灵魂的锚
    },
    reflection: "今天我在神的哪些应许上抛锚我的盼望？"
  },
  {
    type: "transformation",
    content: "属灵的转变是一个持续的过程，我们每天都更加像基督的形象",
    reference: "哥林多后书 3:18",
    category: "成长",
    strongNumbers: {
      "变成": "G3339", // μεταμορφόω (metamorphoo) = 完全改变
      "荣光": "G1391" // δόξα (doxa) = 神圣荣耀
    },
    reflection: "今天我生命的哪些方面需要转变？"
  }
];

export default bibleTreasures;
